// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';

const AttentionModal = ({handle, onOpen, isOpen, onClose, title, description}) => {
  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple modal_take-a-part" 
              maxW={{ sm: '620px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
          <ModalCloseButton style={{zIndex: '9'}} />
              <Box bg="rgba(64, 155, 255, 0.82)" filter="blur(70px)" w="90%" h="150px"
                  transform="translate(-50%, 0px)" left="50%" 
                  top="-200px" position="absolute" borderRadius="full" />

              <Box position="relative" p="0 8px 0 8px" textAlign="center">
                  <Text 
                      variant="title-lg"
                      zIndex="3" 
                      pt="24px"
                      fontSize="32px"
                      fontStyle="italic"
                      fontWeight="700"
                      position="relative">{ title }</Text>

                  <Text mt="16px" fontStyle="italic" p={{base: '0', md: '0 40px'}}>
                      { description }
                  </Text>

                  <Flex  mt="40px" gap="12px">
                    <Button variant="secondary-md" onClick={() => { onClose(); }}>Cancel</Button>
                    <Button variant="button-md" onClick={() => { handle(); onClose(); }}>Continue</Button>
                  </Flex>
              </Box>
          </ModalContent>
        </Modal> 
      </>
  );
};

export default AttentionModal;